<template lang="pug">
table.product-detail
    tr(v-for="item in dataShow")
        td
            span(v-html="item.text")
</template>

<style lang="scss">
.product-detail {
    border: none;

    td, th {
        border: none;
        font-size: 12px;
        // padding: 7px 0;
        padding: 0;
        vertical-align: top;
    }

    th {
        min-width: 60px;
    }

    td {
        // padding: 5px 10px;

        p:first-child {
            margin-top: 0;
        }

        p:last-child {
            margin-bottom: 0;
        }
    }
}
</style>
<script>
export default {
    name: "NseProductDetail",
    props: {
        fields: {
            type: Array,
            default() {
                return []
            }
        },
        selected: {},
        prices: {},
        selected_full: {},

    },
    computed:{
        dataShow() {
            var product_finish = (this.selected_full.product_finish.value)
            var poster_frame = (this.selected_full.poster_frame.value)

            if (product_finish == 'poster' && poster_frame != 'none') {
                product_finish = 'poster_f';
            }

            var dataShow = nse_config.product_details[product_finish].detail;
            return dataShow;
        }
    },

    mounted() {

    }
}
</script>
